var _rect, _line, _circle, _circle2, _circle3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 179,
    viewBox: "0 0 216 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 179,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 30.5,
    x2: 216,
    y2: 30.5,
    stroke: "#E2E2E2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 14.5,
    r: 2.5,
    fill: "#6D6D6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 105.5H195.188C198.107 105.5 200.5 107.947 200.5 111V162C200.5 165.053 198.107 167.5 195.188 167.5H20.8125C17.8933 167.5 15.5 165.053 15.5 162V111C15.5 107.947 17.8933 105.5 20.8125 105.5Z",
    fill: "white",
    stroke: "#747776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.322 114H27.6782C25.6468 114 24 115.791 24 118C24 120.209 25.6468 122 27.6782 122H180.322C182.353 122 184 120.209 184 118C184 115.791 182.353 114 180.322 114Z",
    fill: "#747776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 126H28C25.7909 126 24 127.791 24 130C24 132.209 25.7909 134 28 134H58C60.2091 134 62 132.209 62 130C62 127.791 60.2091 126 58 126Z",
    fill: "#747776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempText);
export default __webpack_public_path__ + "static/media/temp-text.b3c53b11e87aa199e10889e996f18939.svg";
export { ForwardRef as ReactComponent };